import React, { useState } from 'react';
import moment from 'moment';
import { Table } from 'reactstrap';
import { useSelector } from 'react-redux';

import { color } from '~/assets/styles/colors';
import { symbolPriceFormatter } from '~/helpers/price';
import { ModalVisualizarSN } from '~/components/ModalSemNotas/VisualizarPedido';
import { TrStyled } from './styles';

export function LancamentosDataSemNotas(props) {
	const { user } = useSelector((state) => state.auth);

	const { lancamentos, toggleVisualizar, setToggleVisualizar } = props;

	const [numPedido, setNumPedido] = useState('');
	const [idPedido, setIdPedido] = useState('');
	const colorItem = {
		aprovado: color.green,
		reprovado: color.red,
		pendente: color.yellow,
		title: color.red,
	};

	return (
		<>
			<Table id="test-table-xls-button" responsive>
				<thead>
					<TrStyled>
						<th>Data</th>
						<th>Ref. Pedido</th>
						<th style={{ textAlign: 'left', paddingLeft: 22 }}>
							{user.dados.cargo.split(" ")[0].toLowerCase() === 'distribuidor' && 'Revendedores'}
							{user.dados.cargo.toLowerCase() === 'industria' && 'Distribuidores'}
						</th>
						<th>Valor</th>
						<th>Status</th>
					</TrStyled>
				</thead>
				<tbody>
					{lancamentos.map((item, index) => {
						return (
							<tr style={{ textAlign: 'center' }} key={`${item.autorizacao}-${index}`}>
								<td>
									{moment(item.data_pedido).format(
										'DD/MM/YYYY'
									)}
								</td>
								<td>{item.numero_pedido}</td>
								<td style={{ textAlign: 'left' }}>{item.nome_destinatario}</td>
								<td>
									{symbolPriceFormatter(item.valor_pedido)}
								</td>
								<td
									style={{
										fontWeight: 'bold',
										color: colorItem[
											item.status.toLowerCase()
										],
										cursor: "pointer"
									}}>
									<button
										onClick={() => {
											if (user.dados.permissoes.view_nf) {
												setNumPedido(
													item.numero_pedido
												);
												setIdPedido(item.id);
												setToggleVisualizar(
													!toggleVisualizar
												);
											}
										}}
										style={{ all: 'unset' }}
										type="button">
										{item.status.toLowerCase() ===
											'pendente' ? (
											'Pendente'
										) : (
											<>
												{item.status.toLowerCase() ===
													'aprovado'
													? 'Aprovado'
													: 'Reprovado'}
											</>
										)}
									</button>
								</td>
							</tr>
						);
					})}
				</tbody>
			</Table>
			<ModalVisualizarSN
				user={user}
				numPedido={numPedido}
				idPedido={idPedido}
				tipo="solicitados"
				setToggle={setToggleVisualizar}
				toggle={toggleVisualizar}
			/>
		</>
	);
}
